import Vue from 'vue';
import Vuex from 'vuex';
import * as api from "./api";

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        user: null
    },
    getters: {
        getUser: state => {
            return state.user;
        }
    },
    mutations: {
        setUser(state, user) {
            state.user = user;
        }
    },
    actions: {
        getUser(context) {
            adamApi.get(api.logged).then(response => {
                if (response.status === 200) {
                    let user = response.data;
                    context.commit('setUser', user);
                }
            })
        }
    }
});
